export const deepEqual = (leftValue: unknown, rightValue: unknown): boolean => {
  if (leftValue === rightValue) {
    return true;
  }

  if (typeof leftValue !== 'object' || leftValue === null || typeof rightValue !== 'object' || rightValue === null) {
    return false;
  }

  const leftKeys = Object.keys(leftValue);
  const rightKeys = Object.keys(rightValue);

  if (leftKeys.length !== rightKeys.length) {
    return false;
  }

  for (const key of leftKeys) {
    if (
      !rightKeys.includes(key) ||
      !deepEqual((leftValue as Record<string, unknown>)[key], (rightValue as Record<string, unknown>)[key])
    ) {
      return false;
    }
  }

  return true;
};

export type Entries<T> = { [K in keyof T]: [K, T[K]] }[keyof T];

export const objectEntries: <T extends object>(obj: T) => ReadonlyArray<Entries<T>> = Object.entries;

export function strictEntries<T extends object>(obj: T): ReadonlyArray<Entries<T>>;
export function strictEntries<K extends string | number | symbol, V>(obj: Record<K, V>): ReadonlyArray<[K, V]>;
export function strictEntries(obj: object): ReadonlyArray<unknown> {
  return Object.entries(obj);
}

export function definedEntries<K extends string | number | symbol, V>(
  obj: Partial<Record<K, V>>,
): ReadonlyArray<[K, V]> {
  return Object.entries(obj) as [K, V][];
}

export const objectKeys: <T extends object>(obj: T) => ReadonlyArray<keyof T> = Object.keys;
export const objectValues: <T extends object>(obj: T) => Array<T[keyof T]> = Object.values;

export function associateBy<T, K extends string | number | symbol>(array: T[], keyFn: (item: T) => K): Record<K, T> {
  return Object.fromEntries(array.map((item) => [keyFn(item), item])) as Record<K, T>;
}
